import {Component, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';

import {debounceTime} from 'rxjs/operators';
import {Subject} from 'rxjs';


import {PageRequest} from '../../../../core';
import {AuthUser, TokenService} from '../../../../core/auth';
import {User, UserResponse} from '../../../../core/models';
import {UserService} from '../../../../core/services';
import {BreadcrumbService} from '../../../../breadcrumb.service';
import {ConfirmationService, SelectItem} from 'primeng/api';


@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.page.html'
})
export class UserListPage implements OnInit {
  @Input() query = new PageRequest();
  private searchTerms = new Subject<PageRequest>();
  userResponse = new UserResponse();
  users: User[];

  loading = true;
  authUser: AuthUser = this.token.whoAmI();

  statusOptions: SelectItem[];
  selectedStatus: string;

  constructor(
    private router: Router,
    private userService: UserService,
    private token: TokenService,
    private breadcrumbService: BreadcrumbService,
    private confirmationService: ConfirmationService
  ) {
    this.breadcrumbService.setItems([
      {label: 'admin', routerLink: ['/admin', , 'dashboard']},
      {label: 'user'},
      {label: 'list'},
    ]);

    this.statusOptions = [
      {label: 'Status', value: 'EMPTY'},
      {label: 'Active', value: 'A'},
      {label: 'Inactive', value: 'I'},
    ];

    this.selectedStatus = this.statusOptions[0].value;
  }

  ngOnInit() {
    this.searchTerms.pipe(debounceTime(500)).subscribe(
      (query) => {
        this.getUsers(query);
      }
    );
  }

  navigateToCreateNew() {
    this.router.navigate(['/admin', 'user']);
  }

  search(query: PageRequest): void {
    this.searchTerms.next(query);
  }

  paginate(event) {
    this.query.page = (event.first / event.rows) + 1;
    this.query.sortField = event.sortField !== undefined ? event.sortField : 'name';
    this.query.sortDir = this.query.getSortDir(event.sortOrder);

    this.getUsers(this.query);
  }

  getUsers(query?: PageRequest): void {
    this.loading = true;
    this.query.status = this.selectedStatus;
    this.userService.search(query).subscribe(
      (data) => {
        this.userResponse = data;
        delete (this.loading);
      }, (error) => {
        delete (this.loading);
      }
    );
  }


  confirmDelete(user: User) {
    console.log("deleting user");
    this.confirmationService.confirm({
      header: 'Delete User',
      message: 'By clicking the button below you will delete this user',
      rejectVisible: false,
      acceptLabel: ' Proceed',
      accept: () => {
        this.delete(user);
      }
    });
  }

  delete(user: User): void {
    this.userService.delete(user.id).subscribe((data) => {
          this.getUsers(this.query);
        },
        (error) => {
          this.getUsers(this.query);
        });
    // this.reload(2000);
  }


}
